import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import Icon from './Icon';
import s from './ContextMenu.module.css';

// A right-click menu at the cursor: items [{ key, icon, label, hint?, danger?, run } | 'sep' | { head }]. Arrow keys +
// Enter work, Esc / a click elsewhere closes; it keeps itself on screen.
export default function ContextMenu({ x, y, items, onClose }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ left: x, top: y });
  const acts = items.filter((it) => it && it !== 'sep' && !it.head);
  const [i, setI] = useState(0);
  useLayoutEffect(() => {
    const r = ref.current?.getBoundingClientRect(); if (!r) return;
    setPos({ left: Math.min(x, window.innerWidth - r.width - 8), top: Math.min(y, window.innerHeight - r.height - 8) });
  }, [x, y]);
  useEffect(() => {
    const out = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    const key = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); onClose(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); setI((v) => (v + 1) % acts.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setI((v) => (v - 1 + acts.length) % acts.length); }
      else if (e.key === 'Enter') { e.preventDefault(); acts[i]?.run(); onClose(); }
    };
    document.addEventListener('mousedown', out, true);
    document.addEventListener('keydown', key, true);
    window.addEventListener('blur', onClose);
    return () => { document.removeEventListener('mousedown', out, true); document.removeEventListener('keydown', key, true); window.removeEventListener('blur', onClose); };
  }, [onClose, acts, i]);
  let k = -1;
  return (
    <div ref={ref} className={s.menu} style={pos} role="menu" onContextMenu={(e) => e.preventDefault()}>
      {items.map((it, n) => {
        if (!it) return null;
        if (it === 'sep') return <div key={n} className={s.sep} />;
        if (it.head) return <div key={n} className={s.head}>{it.head}</div>;
        k++;
        const idx = k;
        return (
          <button key={it.key} role="menuitem" className={s.item} data-on={idx === i || undefined} data-danger={it.danger || undefined}
            onMouseEnter={() => setI(idx)} onClick={() => { it.run(); onClose(); }}>
            <Icon name={it.icon} size={15} /><span className={s.label}>{it.label}</span>{it.hint ? <span className={s.hint}>{it.hint}</span> : null}
          </button>
        );
      })}
    </div>
  );
}
